import { render, staticRenderFns } from "./AmapayBrand.vue?vue&type=template&id=18f8548b&"
import script from "./AmapayBrand.vue?vue&type=script&lang=js&"
export * from "./AmapayBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports